import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, EnvelopeSimple } from "@phosphor-icons/react";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
    } catch (_) {
      // Always show the same confirmation (don't reveal whether the email exists)
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md surface-card shadow-sm p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-md bg-blue-600 flex items-center justify-center">
            <Ticket weight="fill" size={20} className="text-white" />
          </div>
          <div className="font-display font-bold text-lg tracking-tight">Support By ERP4U</div>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="w-12 h-12 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center mx-auto mb-3">
              <EnvelopeSimple size={22} />
            </div>
            <h2 className="font-display text-xl font-bold text-slate-900">Check your email</h2>
            <p className="text-sm text-slate-500 mt-2">
              If an account exists for <span className="font-medium text-slate-700">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.
            </p>
            <Link to="/login" className="inline-block mt-5 text-sm text-blue-600 hover:underline font-medium">Back to sign in</Link>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Forgot your password?</h2>
            <p className="text-sm text-slate-500 mt-1.5 mb-6">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold uppercase tracking-wide text-slate-500">Email</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="forgot-submit-button">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <div className="text-xs text-slate-500 text-center mt-5">
              <Link to="/login" className="text-blue-600 hover:underline font-medium">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
